import { memo, useCallback, useEffect, useRef } from 'react'

import { Box } from '@mui/material'
import { ContentRepositoryReservation } from '@nativewaves/nw-cloud-sdk/content'

import { Editor, EditorInstance } from '@shared/components/Editor'
import { updateReservations } from 'domains/Workspaces/Settings/Reservations/updateReservations'
import { useRepositoryUpdateMutation } from 'hooks/mutations/content'

type EditorRowProps = {
  repositoryId: string
  index: number
  reservation: ContentRepositoryReservation
}

const EditorRowRaw = ({ repositoryId, index, reservation }: EditorRowProps) => {
  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const repositoryUpdateMutation = useRepositoryUpdateMutation()

  const handleSave = useCallback(
    (value: ContentRepositoryReservation) => {
      const repository = updateReservations({ operation: 'update', repositoryId, reservation: value, index })

      repositoryUpdateMutation.mutate({
        repositoryId,
        contentRepositoryEdit: repository,
      })
    },
    [index, repositoryId, repositoryUpdateMutation],
  )

  useEffect(() => {
    if (editorInstanceRef.current && !!reservation) {
      editorInstanceRef.current?.getModel()?.setValue(window.JSON.stringify(reservation, null, 4))
    }
  }, [reservation])

  return (
    <Box sx={{ width: '100%', height: 640, display: 'flex', position: 'relative', zIndex: 0 }}>
      <Editor
        value={reservation}
        onSubmit={handleSave}
        getEditorInstance={(editorInstance: EditorInstance) => (editorInstanceRef.current = editorInstance)}
      />
    </Box>
  )
}

export const EditorRow = memo(EditorRowRaw)
